import styled from 'styled-components';

import { ProgressItem } from '.';
import { useFnol } from '../context';

const ProgressBar = () => {
  const { fnolCategories } = useFnol();

  return (
    <ProgressList>
      <ProgressItem progressStep={1} />
      <ProgressItem progressStep={2} />
      <ProgressItem progressStep={3} />
      <ProgressItem progressStep={4} />
      <ProgressItem progressStep={5} />
      <ProgressItem progressStep={6} />
      {fnolCategories.length > 1 && <ProgressItem progressStep={7} />}
    </ProgressList>
  );
};

export default ProgressBar;

const ProgressList = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 2rem 0;
`;
